<template>
    <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-gray-800">
      <!-- Logo institucional -->
      <div class="flex justify-center mb-8">
        <img
          src="/favicon.ico"
          alt="Nat Spa and Wellness Center"
          class="h-16 object-contain"
        />
      </div>
  
      <!-- Encabezado legal -->
      <h1 class="text-2xl sm:text-3xl font-bold text-center mb-6 text-gray-900">
        Política de Cancelación y Reembolso de Depósitos
      </h1>
  
      <!-- Cuerpo del texto -->
      <div class="space-y-6 text-justify leading-relaxed text-base sm:text-lg">
        <p>
          En cumplimiento de las prácticas legales vigentes para la protección de
          consumidores y la gestión de servicios profesionales de bienestar, 
          <strong>Nat Spa and Wellness Center</strong>
          establece la siguiente política de cancelación y reembolso, la cual
          es aceptada por el paciente al momento de solicitar una cita mediante
          nuestra plataforma.
        </p>
  
        <h2 class="text-lg font-semibold text-gray-800">1. Confirmación de la Cita</h2>
        <p>
          Una vez que la cita es aprobada por el personal administrativo de 
          <strong>Nat Spa and Wellness Center</strong>, se genera de forma automática un cobro correspondiente a un
          depósito parcial del valor total del servicio solicitado. Esta acción
          constituye un compromiso contractual entre el paciente y el centro.
        </p>
  
        <h2 class="text-lg font-semibold text-gray-800">2. Cambios o Cancelaciones</h2>
        <p>
          El paciente dispone de un plazo de hasta <strong>48 horas antes</strong>
          de la hora programada para realizar cualquier modificación o cancelación
          sin incurrir en penalización alguna. Dichas gestiones deben ser
          efectuadas a través de los canales oficiales de contacto.
        </p>
  
        <h2 class="text-lg font-semibold text-gray-800">3. Casos de Fuerza Mayor</h2>
        <p>
          <strong>Nat Spa and Wellness Center</strong> se reserva el derecho de 
          modificar o cancelar una cita aprobada
          en caso de que se presenten circunstancias de fuerza mayor,
          imprevistos médicos, fallas operativas o cualquier situación que pueda
          ser razonablemente evidenciada. En tales casos, se procurará notificar
          con antelación y ofrecer alternativas de reprogramación.
        </p>
  
        <h2 class="text-lg font-semibold text-gray-800">4. Inasistencia sin Notificación</h2>
        <p>
          En caso de inasistencia del paciente a la cita agendada sin previo
          aviso, <strong>el depósito no será reembolsable bajo ninguna
          circunstancia</strong>, independientemente del motivo. Esta disposición
          aplica sin distinción de edad, condición personal o reincidencia.
        </p>
  
        <h2 class="text-lg font-semibold text-gray-800">5. Aceptación y Vigencia</h2>
        <p>
          Esta política entra en vigencia a partir del momento de su publicación
          y es de aceptación obligatoria para todos los usuarios que reserven
          servicios a través de <strong>Nat Spa and Wellness Center</strong>. La aceptación queda registrada
          electrónicamente como parte del proceso de solicitud.
        </p>
  
        <!-- Fecha -->
        <p class="mt-10 text-sm text-gray-600 text-center">
          Última actualización: {{ fechaHoy }}
        </p>
      </div>
    </div>
  </template>
  
  <script setup>
  const fechaHoy = new Date().toLocaleDateString("es-ES", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  </script>
  